import { Conversation, Message } from '../types/wa_messages';

// Helper to get CSW status using latest WhatsApp inbound message only
export function getCSWStatus(conv: Conversation, messages?: Message[]): { closed: boolean, closeTime: Date | null } {
  // First, try to use last_inbound_wa_msg_received_at from conversation (most reliable)
  if (conv.last_inbound_wa_msg_received_at) {
    const lastInbound = new Date(conv.last_inbound_wa_msg_received_at);
    const closeTime = new Date(lastInbound.getTime() + 24 * 60 * 60 * 1000);
    const closed = new Date() > closeTime;
    return { closed, closeTime };
  }
  
  // Fallback: Find the latest WhatsApp inbound message from messages array if provided
  let latestWhatsAppInbound: Message | null = null;
  
  if (messages && messages.length > 0) {
    // Filter for WhatsApp inbound messages and sort by timestamp (newest first)
    const whatsappInboundMessages = messages
      .filter(msg => msg.channel === 'whatsapp' && msg.direction === 'inbound')
      .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
    
    if (whatsappInboundMessages.length > 0) {
      latestWhatsAppInbound = whatsappInboundMessages[0];
    }
  }
  
  // If not found in messages array, check latest_message if it's WhatsApp inbound
  if (!latestWhatsAppInbound && conv.latest_message) {
    if (conv.latest_message.channel === 'whatsapp' && conv.latest_message.direction === 'inbound') {
      latestWhatsAppInbound = conv.latest_message;
    }
  }
  
  // If there's no latest WhatsApp inbound message, consider CSW as closed without timestamp
  if (!latestWhatsAppInbound) {
    return { closed: true, closeTime: null };
  }
  
  // Calculate CSW status based on latest WhatsApp inbound message timestamp
  const lastInbound = new Date(latestWhatsAppInbound.timestamp);
  const closeTime = new Date(lastInbound.getTime() + 24 * 60 * 60 * 1000);
  const closed = new Date() > closeTime;
  return { closed, closeTime };
} 